import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { ReatoForm } from 'src/app/common/form/reato-form';
import { Reato } from 'src/app/common/models/reato';
import { SezioneReatiResponse } from 'src/app/common/models/dto/sezione-reati-response';
import { SezioneReati } from 'src/app/common/models/sezioni/sezione-reati';

@Component({
    selector: 'div [reato-form-add]',
  templateUrl: '../../../form/reato-form.html'
})

export class ReatiAddComponent extends ReatoForm {
  idSezione: string;
  urlInsert: string;
  urlReadSezioneAltreParti: string;
  urlReadSezioneControparti: string;
  fascicolo: FascicoloFull;
  @Output() onReturn: EventEmitter<SezioneReati> = new EventEmitter<SezioneReati>();

  constructor(@Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, @Inject(HelpersService) helpers: HelpersService) {
        super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Aggiungi Reato');
    this.isInserimento(true);
  }

  getReato() {
    return new Reato();
  }

  getUrlReadSezioneAltreParti() {
    return this.urlReadSezioneAltreParti;
  }

  getUrlReadSezioneControparti() {
    return this.urlReadSezioneControparti;
  }

  getRequest(reato: Reato) {
    this.operationService.addReato(this.urlInsert, reato, this.idSezione, this.fascicolo.id).subscribe((response: any) => this.datiReato(response));
  }

  datiReato(response: SezioneReatiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(idSezione: string, fascicolo: FascicoloFull, urlInsert: string, urlReadSezioneAltreParti: string, urlReadSezioneControparti: string) {
    this.idSezione = idSezione;
    this.urlInsert = urlInsert;
    this.fascicolo = fascicolo;
    this.urlReadSezioneAltreParti = urlReadSezioneAltreParti;
    this.urlReadSezioneControparti = urlReadSezioneControparti;
    this.createForm();
    // if (this.sections.altreParti && this.sections.controparti) {
    if (this.sections.controparti) {
      this.populateSelect();
    } else {
      //this.readSezioneAltreParti(fascicolo.idSezioneAltreParti);
      this.readSezioneControparti(fascicolo.idSezioneControparti);
    }
  }
}
